export default __webpack_public_path__ + "static/media/actividad-34.8e09c15f.mp3";